__turbopack_context__.v({
  "energy-type": "ProductLookup-module-scss-module__qNS37q__energy-type",
  "energy-type__field": "ProductLookup-module-scss-module__qNS37q__energy-type__field",
  "energy-type__field-inner": "ProductLookup-module-scss-module__qNS37q__energy-type__field-inner",
  "errors": "ProductLookup-module-scss-module__qNS37q__errors",
  "errors__icon": "ProductLookup-module-scss-module__qNS37q__errors__icon",
  "product-lookup": "ProductLookup-module-scss-module__qNS37q__product-lookup",
  "product-lookup-wrapper": "ProductLookup-module-scss-module__qNS37q__product-lookup-wrapper",
  "product-lookup__submit": "ProductLookup-module-scss-module__qNS37q__product-lookup__submit",
  "promo": "ProductLookup-module-scss-module__qNS37q__promo",
  "promo__checkbox": "ProductLookup-module-scss-module__qNS37q__promo__checkbox",
  "promo__clear": "ProductLookup-module-scss-module__qNS37q__promo__clear",
  "promo__field": "ProductLookup-module-scss-module__qNS37q__promo__field",
  "promo__icon": "ProductLookup-module-scss-module__qNS37q__promo__icon",
  "promo__input-wrapper": "ProductLookup-module-scss-module__qNS37q__promo__input-wrapper",
});
